import styled, { css } from 'styled-components'

import { Button } from '@audio-network/componentlibrary'
import { ChevronDown } from '@audio-network/componentlibrary/icons'

export const FieldWrap = styled.div`
	display: flex;
	position: relative;
	border: 0.0625rem solid ${(props) => props.theme.colors.ui4};
	border-radius: 2px;
	overflow: visible;
	margin-bottom: 0.25em;

	transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

	:focus,
	:hover {
		border-color: ${(props) => props.theme.colors.ui1};
		box-shadow: 0px 2px 8px 1px rgba(1, 1, 1, 0.1);
	}

	${(props) =>
		props.hasError &&
		css`
			border-color: ${(props) => props.theme.colors.textError} !important;
		`}
`

export const Form = styled.form`
	margin-top: 1.5rem;
`

export const FieldLabel = styled.label`
	font-weight: 600;
	display: block;
	margin-bottom: 0.25rem;

	${(props) =>
		props.hasError &&
		css`
			color: ${(props) => props.theme.colors.textError} !important;
		`}
`

export const FieldChevronDown = styled(ChevronDown)`
	position: absolute;
	top: 50%;
	right: 0.2em;
	display: block;
	width: 1em;
	height: 1em;
	transform: translateY(-50%);
	pointer-events: none;
	line-height: 1.25;

	& * {
		transition: all ease-in-out 0.15s;
		fill: none;
		stroke: ${(props) => props.theme.colors.ui2};
		vector-effect: non-scaling-stroke;
		stroke-linejoin: round;
		stroke-linecap: round;
	}

	&:hover > * {
		stroke: ${(props) => props.theme.colors.ui1};
	}
`

const fieldStyles = css`
	width: 100%;
	font-size: inherit;
	font-family: inherit;
	min-width: 1px; // Fix for the firefox and flexbox bug
	padding: 0.6em 0.6em;
	color: inherit;
	line-height: 1.25;
	background-color: ${(props) => props.theme.colors.backgroundPrimary};
	border: 1px solid ${(props) => props.theme.colors.ui2};
	border-radius: 2px;
	outline: none;
	box-shadow: none;
	transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
	-webkit-appearance: none;

	&::-moz-placeholder {
		color: ${(props) => props.theme.colors.ui2};
	}

	&::-webkit-input-placeholder {
		color: ${(props) => props.theme.colors.ui2};
	}

	&:-ms-input-placeholder {
		color: ${(props) => props.theme.colors.ui2};
	}

	&:hover {
		border-color: ${(props) => props.theme.colors.ui1};
		box-shadow: ${(props) => props.theme.shadows.default};

		& ~ ${FieldChevronDown} * {
			stroke: ${(props) => props.theme.colors.ui1};
		}
	}

	&:focus {
		border-color: ${(props) => props.theme.colors.ui1};
		outline: none;
		box-shadow: ${(props) => props.theme.shadows.hover};

		& ~ ${FieldChevronDown} * {
			stroke: ${(props) => props.theme.colors.ui1};
		}
	}
`

export const FieldInput = styled.input`
	${fieldStyles}

	${(props) =>
		props.error &&
		css`
			padding-right: 0.6em * 2 + 1em;
			border-color: ${(props) =>
				props.theme.colors.uiError} !important; //needs error colour work
		`}
`

export const FieldSelect = styled.select`
	${fieldStyles}

	padding-right: 2.5rem;

	${(props) =>
		props.error &&
		css`
			border-color: ${(props) =>
				props.theme.colors.uiError} !important; //needs error colour work
		`};
`
export const FieldCheckboxWrap = styled.div`
	display: flex;
	align-items: center;
	padding-top: 0.25rem;
`

export const FieldCheckbox = styled.input`
	display: block;
	position: relative;
	height: 2rem;
	width: 2rem;
	cursor: pointer;

	&:before {
		border: 0.0625rem solid ${(props) => props.theme.colors.ui4};
		box-shadow: 0;
		content: '';
		display: block;
		height: 1.25rem;
		inset: 50% 0 0 50%;
		position: absolute;
		transform: translate(-50%, -50%);
		transition: 150ms background-color ease-in-out,
			250ms border-color ease-in-out, 250ms box-shadow ease-in-out;
		width: 1.25rem;
	}

	&:hover:before {
		border: 0.0625rem solid ${(props) => props.theme.colors.ui1};
		box-shadow: ${(props) => props.theme.shadows.default};
	}

	&:checked:before {
		background-color: ${(props) => props.theme.colors.ui1};
	}

	&:checked:after {
		border-bottom: 0.0625rem solid ${(props) => props.theme.colors.textInverse};
		border-right: 0.0625rem solid ${(props) => props.theme.colors.textInverse};
		display: block;
		content: '';
		height: 0.75rem;
		inset: 50% 0 0 50%;
		position: absolute;
		transform: rotate(45deg) translate(-50%, -50%);
		transform-origin: top;
		width: 0.25rem;
	}
`
export const FieldCheckboxLabel = styled.label`
	margin-left: 0.25rem;
`

export const ErrorMessage = styled.span`
	display: block;
	color: ${(props) => props.theme.colors.textError};
`
export const ButtonWrapper = styled.div`
	margin-top: 2rem;
	display: flex;
	width: 100%;
	justify-content: end;
`

export const SubmitButton = styled(Button)``
